<template>
  <header>
    <nav class="navbar navbar-expand-md ">
      <div class="container-fluid align-items-sm-center">
        <router-link to="/Home" class="navbar-brand">
          <img :src="$t('Header.BrandLogo')" alt="Brand Logo" class="img-fluid" />
        </router-link>

        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbar-Nav"
          @click="toggleCollapse"
          aria-controls="navbar-Nav"
          aria-expanded="false"
          aria-label="Toggle navigation" :class="{ active: isCollapsed }"
        ></button>

        <div :class="{ show: isCollapsed }" class="collapse navbar-collapse justify-content-end my-2" id="navbar-Nav">
          <ul class="navbar-nav mr-auto">
            <li class="nav-item">
              <router-link to="/Home" class="nav-link text-uppercase">
                {{$t('Header.HomeTab')}}
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/Upload" class="nav-link text-uppercase">
                {{$t('Header.UploadTab')}}
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/Support" class="nav-link text-uppercase">
                {{$t('Header.SupportTab')}}
              </router-link>
            </li>
          </ul>

         <div class="top-social-nav">
            <ul class="list-inline m-0">
              <li>
                <a href="https://www.youtube.com/cheezit" class="yt-link social-icon" title="youtube" target="_blank">
                  <i class="fab fa-youtube"></i>
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/cheezit" class="ig-link social-icon" title="instagram" target="_blank">
                  <i class="fab fa-instagram"></i>
                </a>
              </li>
              <li>
                <a href="https://www.tiktok.com/@cheezit?lang=en" class="tiktok-link social-icon" title="tiktok" target="_blank">
                  <i class="fab fa-tiktok"></i>
                </a>
              </li>
              <li>
                <a href="https://x.com/cheezit" class="twitter-link social-icon" title="twitter" target="_blank">
                  <i class="fab fa-x-twitter"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  </header>

  <banner></banner>
</template>

<script>
import banner from '../UI/Banner.vue';
export default {
  components: { banner },
  data() {
    return {
      isCollapsed: false,
      currentLang: 'en', // Initialize with default language
    };
  },
  methods: {
    changeLanguage(lang) {
      this.currentLang = lang; // Update the current language
      this.$i18n.locale = lang; // Change the i18n locale
    },
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    },
  },
  mounted() {
    // Close menu on route change
    this.$router.afterEach(() => {
      this.isCollapsed = false;
    });
  }
};
</script>

